module.exports = __webpack_public_path__ + "media/svg-new/email 1-3b4ba9b2.svg";